export default __webpack_public_path__ + "static/markdown-a9d327ff189c147ea86fbba9ed40ec73.png";